<template>
    <div class="register">
        <div class="dowebok">
            <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form">
                <div class="form sign-up">
                    <div class="register-button">
                        <h2>立即注册</h2>
                        <h6 style="text-align: center;color: gray">用户名不可更改，昵称默认和用户名一样</h6>

                        <el-form-item prop="username">
                            <label>
                                <span>用户名</span>
                            </label>
                            <el-input v-model="registerForm.username" type="text" auto-complete="off" placeholder="用户名">
                                <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
                            </el-input>
                        </el-form-item>

                        <el-form-item prop="password">
                            <label>
                                <span>密码</span>
                            </label>
                            <el-input type="password" v-model="registerForm.password" auto-complete="off" placeholder="密码" show-password>
                                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                            </el-input>
                        </el-form-item>

                        <el-form-item prop="repassword">
                            <label>
                                <span>确认密码</span>
                            </label>
                            <el-input type="password" v-model="registerForm.repassword" auto-complete="off" placeholder="确认密码" show-password>
                                <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                            </el-input>
                        </el-form-item>

                        <el-button
                            class="submit"
                            :loading="loading"
                            size="medium"
                            type="primary"
                            style="width:100%;"
                            @click.native.prevent="handleregister"
                            >
                            <span v-if="!loading">注 册</span>
                            <span v-else>注 册 中...</span>
                            </el-button>
                    </div>
                </div>

                <div class="sub-cont">
                    <div class="img">
                        <div class="img__text m--in">
                            <h2>已有帐号？</h2>
                            <p>有帐号就登录吧，好久不见了！</p>
                        </div>
                        <router-link to="/login">
                            <div class="img__btn">
                                <span class="m--in">登 录</span>
                            </div>
                        </router-link>
                    </div>
                </div>
            </el-form>
        </div>


        <!--<el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form">-->
        <!--<h3 class="title">注册heq帐号</h3>-->
        <!--<h6 style="text-align: center;color: #d03c3c">用户名不可更改，昵称默认和用户名一样</h6>-->

        <!--<el-form-item prop="username">-->
        <!--<el-input v-model="registerForm.username" type="text" auto-complete="off" placeholder="用户名">-->
        <!--<svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--</el-form-item>-->

        <!--<el-form-item prop="password">-->
        <!--<el-input type="password" v-model="registerForm.password" auto-complete="off" placeholder="密码" show-password>-->
        <!--<svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--</el-form-item>-->

        <!--<el-form-item prop="repassword">-->
        <!--<el-input type="password" v-model="registerForm.repassword" auto-complete="off" placeholder="确认密码" show-password>-->
        <!--<svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--</el-form-item>-->

        <!--&lt;!&ndash;<el-form-item prop="password">&ndash;&gt;-->
        <!--&lt;!&ndash;<el-input&ndash;&gt;-->
        <!--&lt;!&ndash;v-model="registerForm.password"&ndash;&gt;-->
        <!--&lt;!&ndash;type="password"&ndash;&gt;-->
        <!--&lt;!&ndash;auto-complete="off"&ndash;&gt;-->
        <!--&lt;!&ndash;placeholder="密码"&ndash;&gt;-->
        <!--&lt;!&ndash;@keyup.enter.native="handleregister"&ndash;&gt;-->
        <!--&lt;!&ndash;&gt;&ndash;&gt;-->
        <!--&lt;!&ndash;<svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />&ndash;&gt;-->
        <!--&lt;!&ndash;</el-input>&ndash;&gt;-->

        <!--&lt;!&ndash;</el-form-item>&ndash;&gt;-->
        <!--&lt;!&ndash;            <el-form-item prop="code">-->
        <!--<el-input-->
        <!--v-model="registerForm.code"-->
        <!--auto-complete="off"-->
        <!--placeholder="验证码"-->
        <!--style="width: 63%"-->
        <!--@keyup.enter.native="handleregister"-->
        <!--&gt;-->
        <!--<svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />-->
        <!--</el-input>-->
        <!--<div class="register-code">-->
        <!--<img :src="codeUrl" @click="getCode" class="register-code-img"/>-->
        <!--</div>-->
        <!--</el-form-item>&ndash;&gt;-->
        <!--&lt;!&ndash;<el-checkbox v-model="registerForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>&ndash;&gt;-->
        <!--<el-form-item style="width:100%;">-->
        <!--<el-button-->
        <!--:loading="loading"-->
        <!--size="medium"-->
        <!--type="primary"-->
        <!--style="width:100%;"-->
        <!--@click.native.prevent="handleregister"-->
        <!--&gt;-->
        <!--<span v-if="!loading">注 册</span>-->
        <!--<span v-else>注 册 中...</span>-->
        <!--</el-button>-->
        <!--</el-form-item>-->
        <!--</el-form>-->
    </div>
</template>

<script>
    import {registerByUsername} from "@/api/user";

    export default {
        name: "register",
        data() {
            var validateRepassword = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入确认密码"));
                } else if (value !== this.registerForm.password) {
                    callback(new Error("两次的密码不一致"));
                } else {
                    callback();
                }
            };
            return {
                codeUrl: "",
                cookiePassword: "",
                registerForm: {
                    username: "",
                    password: "",
                    repassword: "",
                    code: "",
                    uuid: ""
                },
                registerRules: {
                    username: [
                        {required: true, trigger: "blur", message: "用户名不能为空"},
                        {min: 1, max: 20, message: '用户名的长度不得超过20个字符', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, trigger: "change", message: "密码不能为空"},
                        {min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'change'}
                    ],
                    repassword: [
                        {required: true, validator: validateRepassword, trigger: "change"},
                        {min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'change'}
                    ],
                    // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
                },
                loading: false,
                redirect: undefined
            };
        },
        created() {

        },
        methods: {
            //注册的点击事件
            handleregister() {
                this.$refs.registerForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        console.log(this.registerForm)
                        registerByUsername(this.registerForm).then(response => {
                            // 响应成功回调
                            if (response.code == 200) {
                                this.$message({
                                    showClose: true,
                                    message: response.msg,
                                    type: 'success'
                                });
                                this.$router.push({path: this.redirect || "/login"});
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.msg,
                                    type: 'error'
                                });
                                this.loading = false;
                            }

                        }).catch(function (response) {
                            // 响应失败回调
                            console.log(response)
                            this.$message({
                                showClose: true,
                                message: response.msg,
                                type: 'error'
                            });
                            this.loading = false;
                        })
                    }
                });
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .register {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-size: cover;
    }
    .register-button{
        width: 50%;
        margin: 0 auto !important;
    }

    .title {
        margin: 0px auto 30px auto;
        text-align: center;
        color: #707070;
    }

    .register-form {
        border-radius: 6px;
        width: 400px;
        padding: 25px 25px 5px 25px;
        .el-input {
            height: 38px;
            input {
                height: 38px;
            }
        }
        .input-icon {
            height: 39px;
            width: 14px;
            margin-left: 2px;
        }
    }

    .register-tip {
        font-size: 13px;
        text-align: center;
        color: #bfbfbf;
    }

    .register-code {
        width: 33%;
        height: 38px;
        float: right;
        img {
            cursor: pointer;
            vertical-align: middle;
        }
    }

    .el-register-footer {
        height: 40px;
        line-height: 40px;
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        color: #fff;
        font-family: Arial;
        font-size: 12px;
        letter-spacing: 1px;
    }

    .register-code-img {
        height: 38px;
    }
</style>

<style scoped>
    *, *:before, *:after {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        /*font-family: 'Open Sans', Helvetica, Arial, sans-serif;*/
        background: #ededed;
    }

    input, button {
        border: none;
        outline: none;
        background: none;
        font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    }

    .tip {
        font-size: 20px;
        margin: 40px auto 50px;
        text-align: center;
    }

    .dowebok {
        overflow: hidden;
        position: relative;
        width: 900px;
        height: 550px;
        margin: 100px auto;
        background: #fff;
    }

    .form {
        position: relative;
        width: 640px;
        height: 100%;
        padding: 50px 30px;
    }

    .sub-cont {
        overflow: hidden;
        position: absolute;
        left: 640px;
        top: 0;
        width: 900px;
        height: 100%;
        padding-left: 260px;
        background: #fff;
    }

    button {
        display: block;
        margin: 0 auto;
        width: 260px;
        height: 36px;
        border-radius: 30px;
        color: #fff;
        font-size: 15px;
        cursor: pointer;
    }

    .img {
        overflow: hidden;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 260px;
        height: 100%;
        padding-top: 360px;
    }

    .img:before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 900px;
        height: 100%;
        /*background-image: url(../images/bg.jpg);*/
        background-size: cover;
    }

    .img:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
    }

    .img__text {
        z-index: 2;
        position: absolute;
        left: 0;
        top: 50px;
        width: 100%;
        padding: 0 20px;
        text-align: center;
        color: #fff;
    }

    .img__text h2 {
        margin-bottom: 10px;
        font-weight: normal;
    }

    .img__text p {
        font-size: 14px;
        line-height: 1.5;
    }

    .img__btn {
        overflow: hidden;
        z-index: 2;
        position: relative;
        width: 100px;
        height: 36px;
        margin: 0 auto;
        background: transparent;
        color: #fff;
        text-transform: uppercase;
        font-size: 15px;
        cursor: pointer;
    }

    .img__btn:after {
        content: '';
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 2px solid #fff;
        border-radius: 30px;
    }

    .img__btn span {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    h2 {
        width: 100%;
        font-size: 26px;
        text-align: center;
    }

    label {
        display: block;
        width: 260px;
        margin: 25px auto 0;
        text-align: center;
    }

    label span {
        font-size: 12px;
        color: #909399;
        text-transform: uppercase;
    }

    input {
        display: block;
        width: 100%;
        margin-top: 5px;
        padding-bottom: 5px;
        font-size: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.4);
        text-align: center;
    }

    .forgot-pass {
        margin-top: 15px;
        text-align: center;
        font-size: 12px;
        color: #cfcfcf;
    }

    .forgot-pass a {
        color: #cfcfcf;
    }

    .submit {
        margin-top: 40px;
        margin-bottom: 20px;
        background: #d4af7a;
        text-transform: uppercase;
    }

    .fb-btn {
        border: 2px solid #d3dae9;
        color: #8fa1c7;
    }

    .fb-btn span {
        font-weight: bold;
        color: #455a81;
    }

</style>

